module.exports = __webpack_public_path__ + "static/media/GrandOuest.8d40f8b2.jpg";